const LOAD_DATA_ORDER           = 'LOAD_DATA_ORDER'
const LOAD_DATA_ORDER_SUCCESS   = 'LOAD_DATA_ORDER_SUCCESS'
const LOAD_DATA_ORDER_FAILED    = 'LOAD_DATA_ORDER_FAILED'
const UNMOUNT_DATA_ORDER        = 'UNMOUNT_DATA_ORDER'
const initialState = {
  loading: true,
  meta: null,
  data: null,
  message: null,
}
const orderReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_ORDER:
      return {
        ...state,
        loading: true,
        meta: null,
        data: null,
      }
    case LOAD_DATA_ORDER_SUCCESS:
      return { 
        ...state, 
        loading: false,
        meta: action.payload.meta,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_ORDER_FAILED:
      return { 
        ...state, 
        loading: true,
        meta: null,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_ORDER:
      return { 
        ...state, 
        loading: true,
        meta: null,
        data: null,
      }
    default:
      return state
  }
}
export default orderReducer;